import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  tooltipHost: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    width: '100%',
  },
  // no idea why passing styles to TooltipHost not working, so use this to workaround
  lineClamp4: {
    WebkitLineClamp: 4,
  },
  lineClamp6: {
    WebkitLineClamp: 6,
  },
  lineClamp8: {
    WebkitLineClamp: 8,
  },
});

export const UnStyledTooltipWrapper = ({
  classes,
  children,
  content,
  lineClamp,
}) => (
  <TooltipHost
    hostClassName={classnames(classes.tooltipHost, classes[`lineClamp${lineClamp}`])}
    overflowMode={TooltipOverflowMode.Self}
    content={content}
  >
    {children}
  </TooltipHost>
);

UnStyledTooltipWrapper.propTypes = {
  classes: PropTypes.shape({
    tooltipHost: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  content: PropTypes.string.isRequired,
  lineClamp: PropTypes.number.isRequired,
};

export const TooltipWrapper = withDefaultStyles(
  UnStyledTooltipWrapper,
  getStyles
);
